// removed by extract-text-webpack-plugin
module.exports = {"summary-data-box":"app-components-receipt-transactions-Summary-__Summary___1sn4a","title-center":"app-components-receipt-transactions-Summary-__Summary___KJ03d","amount":"app-components-receipt-transactions-Summary-__Summary___gqeYT"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/Summary/Summary.css
// module id = 2026
// module chunks = 0